<template>
  <div>
    <!-- Title -->
    <h3 class="mb-6 text-center text-lg font-medium text-gray-600">
      Llámanos
    </h3>

    <!-- Phones -->
    <div
      :class="`grid gap-4`"
      :style="{ gridTemplateColumns: `repeat(${phones.length}, minmax(0, 1fr))` }"
    >
      <div
        v-for="phone in phones"
        :key="phone.id"
        class="text-center"
      >
        <p class="mb-2 text-sm text-gray-500">
          {{ phone.label }}
        </p>

        <a
          :href="`tel:${phone.tel}`"
          class="
    block rounded-lg
    border border-gray-500 bg-white py-3 text-sm text-gray-600
    transition-shadow duration-200
    hover:bg-gray-50
  "
        >
          {{ phone.display }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
export interface PhoneItem {
  id: string
  label: string
  display: string
  tel: string
}

defineProps<{
  phones: PhoneItem[]
}>()

defineEmits<{
  (e: 'back'): void
}>()
</script>
